import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import React from 'react';
import DefaultLayout from './Layout/Layout';
import RequireAuth from './Config/Auth/RequireAuth';
import { authRoutes } from './utils/routes/AuthRoutes';
import { routes } from './utils/routes/Routes';
import Error404 from './Pages/OtherPages/Error/Error404/Error404';
import PermissionWrapper from './Config/Auth/CheckWithPermissions';

const AppRouting: React.FC = () => {
    const router = createBrowserRouter([
        {
            element: (
                <RequireAuth>
                    <DefaultLayout />
                </RequireAuth>
            ),
            children: routes.map((route) => ({
                path: route.path,
                element: route.element ? (
                    <PermissionWrapper permissions={route.permissions}>
                        {route.element}
                    </PermissionWrapper>
                ) : null,
                action: route.action
            }))
        },
        ...authRoutes,
        { path: '*', element: <Error404 /> }
    ]);

    return <RouterProvider router={router} />;
};

export default AppRouting;
